import React, { PureComponent } from 'react'
import { Pane, majorScale, TextInputField, Heading, Code, Button } from 'evergreen-ui'
import DialogLayout from '../DialogLayout'

interface ScanCodeStepProps {
  onTotpTokenInputChange: (value: string) => void
  onClickBack: () => void
  onClickEnable: () => void
  qrCode: string
  secret: string
}

interface ScanCodeStepState {
  isSecretShown: boolean
}

class ScanCodeStep extends PureComponent<ScanCodeStepProps, ScanCodeStepState> {
  state = {
    isSecretShown: false
  }

  toggleSecret = () => {
    this.setState(prevState => ({
      isSecretShown: !prevState.isSecretShown
    }))
  }

  render() {
    const { onTotpTokenInputChange, onClickBack, onClickEnable, qrCode, secret } = this.props

    const { isSecretShown } = this.state

    return (
      <DialogLayout onBackClick={onClickBack} onConfirmClick={onClickEnable} confirmLabel="Enable">
        <Heading size={600} marginBottom={majorScale(3)} textAlign="center">
          Scan the QR code and enter the verification code
        </Heading>

        <Pane>
          <Pane display="flex" flexDirection="column" alignItems="center" marginBottom={majorScale(2)}>
            <img className="fullstory-exclude" src={qrCode} />
            {isSecretShown ? (
              <Code className="fullstory-exclude">{secret}</Code>
            ) : (
              <Button appearance="minimal" onClick={this.toggleSecret}>
                Use secret instead
              </Button>
            )}
          </Pane>

          <TextInputField
            type="number"
            required
            className="fullstory-exclude"
            label="Verification code"
            hint="This should be a 6-digit verification code generated by the app"
            autoFocus
            placeholder="123456"
            autoComplete="one-time-code"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onTotpTokenInputChange(e.target.value)}
            marginBottom="0"
          />
        </Pane>
      </DialogLayout>
    )
  }
}

export default ScanCodeStep
